import RouteWithSubRouters from '../../RouterUtil';

import PropTypes from 'prop-types';
import React from 'react';
import { Switch } from 'react-router-dom';

class AdminProfile extends React.Component {
  static get propTypes() {
    return {
      routes: PropTypes.any,
    };
  }

  render() {
    return (
      <Switch>
        {this.props.routes.map((route, i) => (
          <RouteWithSubRouters key={i} {...route} />
        ))}
      </Switch>
    );
  }
}

export default AdminProfile;
